module.exports = __webpack_public_path__ + "c9550b4f6e71600ec34fac8c60a0316f.jpg";